{
  "version": 1,
  "asset_id": "3ccd1a1a-434c-436b-a089-b47444e2a347",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/3ccd1a1a-434c-436b-a089-b47444e2a347/loc-frisco-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/3ccd1a1a-434c-436b-a089-b47444e2a347/loc-frisco-640.avif",
  "original_filename": "loc-frisco-640.avif",
  "size": 13124,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:24Z"
}
